import React from "react";
import VLibras from "@djpfs/react-vlibras";

export function VLibrasComponent() {
  // Sem forceOnload: essa prop faz a biblioteca chamar window.onload() sem checar se é uma
  // função, o que lança "window.onload is not a function" sempre que nada mais no app
  // atribui window.onload (nosso caso). O único efeito da prop é essa chamada, então
  // removê-la não muda nenhum comportamento real do widget.
  return <VLibras />;
}